import React, { useState } from "react";
import MetaData from "../../components/layout/MetaData";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import CheckoutSteps from "../../components/CheckoutSteps";
import { savePaymentMethod } from "../../redux/features/cartSlice";

const PaymentMethod = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [method, setMethod] = useState("");


  const submitHandler = (e) => {
    e.preventDefault();
     if (method === "WireTransfer") {
       dispatch(savePaymentMethod(method));
       navigate("/confirm_order");
    }
    
    if (method === "Paypal") {
      // Paypal Checkout
      dispatch(savePaymentMethod(method));
      navigate("/confirm_order");
      };
  };

  return (
    <>
      <MetaData title="Payment Method" />
      <CheckoutSteps shipping payment />
      <div className="flex justify-center items-center mt-10">
        <div className="w-full max-w-md">
          <form
            className="shadow-lg rounded bg-white p-4"
            onSubmit={submitHandler}
          >
            <h2 className="text-2xl font-semibold mb-4">
              Select Payment Method
            </h2>
            <div className="form-check mb-4">
              <input
                className="form-radio h-5 w-5 text-blue-600"
                type="radio"
                name="payment_mode"
                id="paypalRadio"
                value="Paypal"
                checked={method === "Paypal"}
                onChange={(e) => setMethod(e.target.value)}
              />
              <label
                className="form-check-label ml-2 text-gray-700"
                htmlFor="paypalRadio"
              >
                PayPal
              </label>
            </div>
            <div className="form-check">
              <input
                className="form-radio h-5 w-5 text-blue-600"
                type="radio"
                name="payment_mode"
                id="WireTransferRadio"
                value="WireTransfer"
                checked={method === "WireTransfer"}
                onChange={(e) => setMethod(e.target.value)}
              />
              <label
                className="form-check-label ml-2 text-gray-700"
                htmlFor="WireTransferRadio"
              >
                Wire Transfer
              </label>
            </div>
            <button
              type="submit"
              className="mt-4 w-full bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
            >   
                Continue
            </button>
          </form>
        </div>
      </div>
    </>
  );
};

export default PaymentMethod;
